export const PATHS = {
    home: '/campaign/created',
    scheduled: '/campaign/scheduled',
    sent: '/campaign/created',
    support: '/support',
    notifications: '/notifications',
    sentPreviewWithoutID: '/campaign/created/preview/'
}

export const ENDPOINTS = {
    translateDictionaries: '/i18n'
}